import { type PropsWithChildren } from 'react';

type CardHeaderProps = PropsWithChildren<{
  expandable?: boolean;
  onClick?: () => void;
}>;

export const CardHeader = ({
  expandable,
  children,
  onClick,
}: CardHeaderProps) => {
  if (expandable) {
    return (
      <button
        type="button"
        className={`flex w-full items-center gap-3 text-left`}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  return <div className={`flex w-full items-center gap-3`}>{children}</div>;
};
